import ga4 from '../lib/ga-helper'

const $signUpModal = $('#signUpModalRecaptcha'),
  $joinCaptureForm = $('#join-capture-form-recaptcha')

if ($signUpModal.length && $joinCaptureForm.length) {
  const $recaptchaTokenInput = $joinCaptureForm.find('.js-recaptcha'),
   $salesforceForm = $signUpModal.find('#salesforce-form')

  new Foundation.Abide($joinCaptureForm)
  $('.recaptcha-error').hide()
  grecaptcha.ready(function() {
    grecaptcha.execute('6LfnK48UAAAAAHI21G_zmOWYDTv0n1VABrlq8MkJ', { action: 'joinCapture' })
      .then(function(token) {
        $recaptchaTokenInput.val(token)
      })
  })
  // Client requested saving users details in Salesforce and redirecting them to an mjol form rather than saving user details in Silverstripe
  $joinCaptureForm.on('formvalid.zf.abide', function(e) {
    e.preventDefault()
    $salesforceForm.find('#js-salesforce-firstname').val($joinCaptureForm.find("#js-join-firstname").val())
    $salesforceForm.find('#js-salesforce-lastname').val($joinCaptureForm.find("#js-join-lastname").val())
    $salesforceForm.find('#js-salesforce-email').val($joinCaptureForm.find("#js-join-email").val())

    const data = $(this).serialize(),
      $submitButton = $(this).find('#join-capture-form-button')
    $submitButton.prop('disabled', true)
    $.ajax({
      type: 'POST',
      url: 'leadCapture/verify_recaptcha',
      data,
      dataType: 'json'
    })
    .done(function(msg) {
      console.log('Reached verify_recaptcha done method for joincapture', {msg})
      if (typeof(msg.success) != 'undefined' && msg.success == true) {
        ga4.trackEvnt('campaign_page_join', {
          'conversion_type': 'Join - submit form',
          'link_text' : $submitButton.text(),
        })
        $signUpModal.foundation('close')
        $salesforceForm.submit()
      } else {
        $('.recaptcha-error').show()
      }
    })
    .fail(function() {
      $('.f-lc__step-one').hide()
      $('.recaptcha-error').show()
    })
    .always(function() {
      ga4.trackEvnt('campaign_page_join', {
        'conversion_type': 'Join - submit form',
        'link_text' : 'Start',
      })
      $submitButton.prop('disabled', false)
      grecaptcha.execute('6LfnK48UAAAAAHI21G_zmOWYDTv0n1VABrlq8MkJ', { action: 'joinCapture'})
        .then(function(token) {
          $recaptchaTokenInput.val(token)
        })
    })
  }).on('submit', function(ev) {
    ev.preventDefault()
  })
}